import { Box, Chip, type Theme } from "@mui/material";

import { brand } from "../../theme/brand";
import { paletteVarAlpha } from "../../theme/palette-var";

const brandPrimaryTint =
  (opacity: number) =>
  (theme: Theme): string =>
    paletteVarAlpha(brand("primary")(theme), opacity);

export interface ChipOption {
  id: string;
  label: string;
  disabled?: boolean;
}

export interface SelectableChipGroupProps {
  options: ChipOption[];
  selected: string[];
  onChange: (id: string) => void;
}

const SelectableChipGroup = ({
  options,
  selected,
  onChange,
}: SelectableChipGroupProps): React.JSX.Element => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
    {options.map((option) => {
      const isSelected = selected.includes(option.id);
      const isDisabled = option.disabled === true;
      return (
        <Chip
          key={option.id}
          label={option.label}
          onClick={isDisabled ? undefined : () => onChange(option.id)}
          disabled={isDisabled}
          variant="outlined"
          sx={{
            borderRadius: "4px",
            cursor: isDisabled ? "not-allowed" : "pointer",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.16px",
            lineHeight: "18px",
            ...(isDisabled
              ? {
                  border: "1px solid",
                  borderColor: "grey.400", // #bdbdbd
                  color: "text.primary", // #00344f
                  backgroundColor: "transparent",
                  opacity: 0.38,
                  "&.Mui-disabled": {
                    opacity: 0.38,
                  },
                }
              : isSelected
                ? {
                    border: "1px solid",
                    borderColor: brand("primary"),
                    backgroundColor: brandPrimaryTint(0.08),
                    color: brand("primary"),
                    "&:hover": {
                      backgroundColor: brandPrimaryTint(0.12),
                    },
                  }
                : {
                    border: "1px solid",
                    borderColor: "grey.400", // #bdbdbd
                    color: "text.primary", // #00344f
                    "&:hover": {
                      backgroundColor: "grey.100",
                    },
                  }),
          }}
        />
      );
    })}
  </Box>
);

export default SelectableChipGroup;
